import React from 'react';
import Styles from './styles.js'
import Link from 'next/link'

export default function ButtonV1({ btnName, px, py, txtColor, mdWidth, acWidth, justify, rounded, mt, btnHref }) {
  return (
    <div className={``}>
      <Link href={`${btnHref}`}>
        <button className={`${px} ${py} ${mt} md:w-${mdWidth} w-${acWidth} V1-btn rounded-${rounded}  transition duration-500 flex items-center text-base justify-${justify}`} style={{ color: `${txtColor}` }}>
          {btnName}
        </button>
      </Link>
      <Styles />
    </div>
  );
}
